// Unica fonte di verità per gli URL dell'API. Fastify li usa direttamente
// (sintassi nativa `:param`); il client interpola i parametri dalle stesse
// costanti.
export const PATHS = {
  health:              '/api/health',
  hello:               '/api/hello',
  whatsappWebhook:     '/api/whatsapp/webhook',
  whatsappAriCallback: '/api/whatsapp/ari-callback/:stateId',
  emailWebhook:        '/api/email/webhook',
} as const
